// import { useState } from 'react';
// import VoxPlayer from './components/VoxPlayer';
// import LoginPage from './components/LoginPage';

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [userData, setUserData] = useState(null);

//   const handleLogin = (credentials) => {
//     // Store user data and authenticate
//     setUserData(credentials);
//     setIsAuthenticated(true);
//   };

//   return (
//     <>
//       {!isAuthenticated ? (
//         <LoginPage onLogin={handleLogin} />
//       ) : (
//         <VoxPlayer userData={userData} />
//       )}
//     </>
//   );
// }

// export default App;




import { useState } from 'react';
import VoxPlayer from './components/VoxPlayer';
import LoginPage from './components/LoginPage';

function App() {

 const params = new URLSearchParams(window.location.search);
 const uid = params.get("uid");

 const [isAuthenticated, setIsAuthenticated] = useState(false);
 const [userData, setUserData] = useState(null);

 const handleLogin = (credentials) => {

   // attach uid if exists
   setUserData({
     ...credentials,
     embedUid: uid
   });

   setIsAuthenticated(true);
 };

 return (
   <>
     {!isAuthenticated ? (
       <LoginPage onLogin={handleLogin} />
     ) : (
       <VoxPlayer userData={userData} />
     )}
   </>
 );
}

export default App;
